import { percentageFieldDefaults } from '../../utils/percentageMetrics'
import {
  getFormValidationMessage,
  getRequestData
} from '../../utils/newHeatMapUtil'
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import HMapDetailsFooter from './HMapDetailsFooter'
import HMapDetailsContent from './HMapDetailsContent'
import { useHMapContext } from '../../hooks/useHMapContext'
import ApiCalls from '../../../../common/ApiCalls'
import { HMapPanels } from '../../const/HMapPanels'

const { HMapDisplay } = HMapPanels

const HMapDetailsNewPanel = ({
  setCurrentPanel,
  operation,
}) => {
  const classes = useStyles()

  const {
    dynamicFieldsRef,
    userIdRef,
    operationsRef,
    currentHeatmapType,
    allHeatMapsList,
    snackbar,
    modal
  } = useHMapContext()

  const [modalPropsRef, setModalOpen] = modal
  const [isSnackbarOpen, setIsSnackbarOpen] = snackbar
  const [heatmapType] = currentHeatmapType
  const [allHeatMaps, setAllHeatMaps] = allHeatMapsList
  const dynamicFields = dynamicFieldsRef.current
  const operations = operationsRef.current
  const userId = userIdRef.current

  const [formFields, setFormFields] = useState({
    heatmapType: heatmapType,
    userId: userId,
    numberSlider: [],
    sizeSlider: [0, 25, 50, 75, 100],
    colorSlider: [0, 35, 100],
    colorHexes: ['#549FF5', '#1DBE1D', '#FDD71A', '#ED1C24'],
    shadowSlider: [0, 35, 65, 100]
  })

  const goToTabPanel = () => setCurrentPanel(HMapDisplay)

  const addNewMapToTheList = (mapId, requestData) => {
    if (!mapId) return console.log('no MapId')

    if (mapId) {
      const mapInfo = {
        id: mapId,
        name: requestData.name,
        description: requestData.description,
        type: requestData.type,
        pin: false,
        star: false
      }

      setAllHeatMaps([ ...allHeatMaps, { ...mapInfo } ])
    }
  }

  const handleOnChange = (e) => {
    const fieldName = e.target.name
    const fieldValue = e.target.value
    const fieldLabel = e.target.text

    setFormFields({
      ...formFields,
      [fieldName]: fieldValue,
      ...percentageFieldDefaults(fieldName, fieldValue, formFields, dynamicFieldsRef.current),
      ...(!!fieldLabel && { [`${fieldName}Label`]: fieldLabel })
    })
  }

  const saveHeatmapToDB = (requestData) => {
    // Save Heatmap
    ApiCalls()
      .saveANewHeatmap(requestData)
      .then((res) => {
        // console.log('SAVE RES =>', res)
        // Snackbar
        setIsSnackbarOpen({
          ...isSnackbarOpen,
          message: 'You added a new heatmap successfully',
          severity: 'success',
          isOpen: true
        })

        setModalOpen(false)
        const mapId = res?.data?.data?.id || undefined
        addNewMapToTheList(mapId, requestData)
        goToTabPanel()
      })
      .catch((err) => {
        console.log(err)
        // Snackbar
        setIsSnackbarOpen({
          ...isSnackbarOpen,
          message: err.message,
          severity: 'fail',
          isOpen: true
        })

        setModalOpen(false)
      })
  }

  const submitHeatMap = (e) => {
    e.preventDefault()
    const validationMessage = getFormValidationMessage(formFields, dynamicFieldsRef.current)
    if (!validationMessage) {
      const requestData = getRequestData(formFields)

      // console.log(formFields)
      // console.log(requestData)

      modalPropsRef.current = {
        ...modalPropsRef.current,
        type: 'save',
        messageText: `Are you sure about saving the new heatmap?`,
        confirmFunction: () => saveHeatmapToDB(requestData)
      }
      setModalOpen(true)
    } else {
      // Snackbar (error)
      setIsSnackbarOpen({
        ...isSnackbarOpen,
        message: validationMessage,
        severity: 'fail',
        isOpen: true
      })
    }
  }

  useEffect(() => {
    // pop an error if no dynamicFields
    if (!dynamicFields || (dynamicFields && !dynamicFields.length)) {
      modalPropsRef.current = {
        ...modalPropsRef.current,
        type: 'error',
        messageText: `We couldn't find any numeric dynamic field. Please contact your system administrator.`
      }
      setModalOpen(true)
    }

    // XXX Fix this in the future
    // eslint-disable-next-line
  }, [])

  return (
    <div className={classes.root}>
      <HMapDetailsContent
        operations={operations}
        dynamicFields={dynamicFields}
        onChange={handleOnChange}
        formFields={formFields}
      />
      <HMapDetailsFooter
        text={'Create Heatmap'}
        onCanel={goToTabPanel}
        onSubmit={submitHeatMap}
      />
    </div>
  )
}

export default React.memo(HMapDetailsNewPanel)

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  }
}))
